export default {
  getCookie: function (name) {
    var arr = document.cookie.split('; ')
    for (var i = 0, len = arr.length; i < len; i++) {
      var item = arr[i].split('=')
      if (item[0] === name) {
        return item[1]
      }
    }
    return ''
  }

}
